<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">Recommended Providers for this Article</h3>
		</header>
		<div class="card-body">
			<p>Properties pulled from Selected Summary Template from above. You can override, by adding some custom property.</p>
			<section class="flex end">
				<div class="form-group mb-0 mr-1 flex-1">
					<label>Select Property Group</label>
					<select3 @change="selectedProperty = null" :value.sync="selectedPropertyGroup" :data="commercialRecommendedProviders.allProperties" :config="propertyGroupSelectConfig"></select3>
				</div>
				<div class="form-group mb-0 mr-1 flex-1">
					<label>Select Property</label>
					<select3 :value.sync="selectedProperty" :data="filteredProperties" :config="propertyGroupSelectConfig"></select3>
				</div>
				<button @click.prevent="addCustomProperty" class="btn btn-primary" :disabled="selectedProperty === null"><i class="fas fa-plus"></i> Add Property</button>
				<button @click.prevent="generateScoredList" class="btn btn-success ml-1"><i class="fas fa-cog"></i> Calculate List</button>
			</section>
			<section class="flex multiple-badges">
				<div title="click to remove" class="badge badge-primary" v-for="property in customPropertiesWithGroupAndName">{{ property.niceName }}
					<i @click="delCustomProperty(property.id)" class="fas fa-times"></i></div>
			</section>
			<section v-if="customScoredList">
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Position</th>
								<th>Provider Name</th>
								<th>Score</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(provider, index) in customScoredList">
								<td>{{ index + 1 }}</td>
								<td>{{ provider.name }}</td>
								<td v-if="provider.custom_score > 0">{{ provider.custom_score }}</td>
								<td v-if="provider.custom_score === 0">{{ provider.ranked_score }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
		</div>
	</div>
</template>

<script>

	import {eventBus} from "../../app";

	export default {
		props: {
			commercialRecommendedProviders: {
				required: true
			}
		},
		data() {
			return {
				selectedPropertyGroup: null,
				selectedProperty: null,

				propertyGroupSelectConfig: {
					keyName: 'id',
					valueName: 'name'
				},

				customScoredList: null,

				checker: null,
				checkerId: null,
			}
		},
		computed: {
			filteredProperties: function () {
				let vm = this;
				if (vm.selectedPropertyGroup === null) {
					return [];
				}
				let propertyGroup = vm.commercialRecommendedProviders.allProperties.find(element => element.id === vm.selectedPropertyGroup);
				return propertyGroup.properties.filter(element => !vm.commercialRecommendedProviders.selectedProperties.find(el => el.id === element.id));
			},
			customPropertiesWithGroupAndName: function () {
				let vm = this;
				let properties = [];
				for (let i = 0; i < vm.commercialRecommendedProviders.selectedProperties.length; i++) {
					let group = vm.commercialRecommendedProviders.allProperties.find(element => element.properties.find(el => el.id === vm.commercialRecommendedProviders.selectedProperties[i].id));
					if (group) {
						let property = group.properties.find(el => el.id === vm.commercialRecommendedProviders.selectedProperties[i].id);
						property['niceName'] = group.name + '/' + property.name;
						properties.push(property);
					}
				}
				return _.orderBy(properties, ['niceName'], ['asc']);
			}
		},
		methods: {
			addCustomProperty: function () {
				let vm = this;
				vm.commercialRecommendedProviders.selectedProperties.push({id: vm.selectedProperty});
				vm.commercialRecommendedProviders.selectedProperties = [...new Set(vm.commercialRecommendedProviders.selectedProperties)];
				vm.selectedProperty = null;
				vm.selectedPropertyGroup = null;
				vm.saveCustomProperties();
			},
			delCustomProperty: function (id) {
				let vm = this;
				vm.commercialRecommendedProviders.selectedProperties = vm.commercialRecommendedProviders.selectedProperties.filter(item => item.id !== id);
				vm.saveCustomProperties();
			},
			saveCustomProperties: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/articles/' + vm.commercialRecommendedProviders.id + '/saveCustomProperties', {
					custom_score_properties: vm.commercialRecommendedProviders.selectedProperties
				}).then(function(response) {
					eventBus.$emit('onLoaderFinish');
					vm.$toastr.success('Property added successfully', 'Success');
				});
			},
			generateScoredList: function () {
				let vm = this;
				let params = {};
				if (vm.checkerId !== null) {
					params = {
						params: {
							id: vm.checkerId
						}
					};
				}
				eventBus.$emit('onLoaderStart');
				axios.get('/api/' + vm.$selectedSite.slug + '/articles/' + vm.commercialRecommendedProviders.id + '/generateCustomScoredList', params)
						.then(response => {
							if (response.data.hasOwnProperty('customScoredList')) {
								if (response.data.customScoredList !== null) {
									eventBus.$emit('onLoaderFinish');
									vm.customScoredList = response.data.customScoredList;
									vm.checkerId = null;
									clearInterval(vm.checker);
								}
							}
							if (response.data.hasOwnProperty('id')) {
								vm.checkerId = response.data.id;
								vm.checker = setInterval(vm.generateScoredList, 5000);
							}
						});
			}
		}
	}
</script>

<style scoped>

</style>
